import {Pipe, PipeTransform} from "@angular/core";
import {InternalNumberStatus} from "../../model/internalNumberStatus";

@Pipe({name: 'internalNumberStatus'})
export class InternalNumberStatusPipe implements PipeTransform {
    transform(value: any) {
        return InternalNumberStatus[value];
    }
}
